export default "__VITE_ASSET__DTH8WZ73__"